module.exports = __webpack_public_path__ + "static/media/teal-arrow-right.6a44935d.svg";